<template>
  <div>
    <h3>Kedves Párok!</h3>

    <p>
      Szeretettel hívunk bennetek idén is a Házasság Hete eseményeire "<i>Hűség, drága kincsem!</i>" mottóval. A mottó is arra utal, hogy a kapcsolatunk
      törékeny kincs, törődést igényel. A meghívott előadóink, a kapcsolat ápolására tudatosan szánt időtök, közös munkálkodásotok teremjen gyümölcsöt!
      Ebben próbálunk segíteni benneteket!
    </p>

    <p class="right-align">HH Team</p>

    <h2>Előadás</h2>
    <div class="list-wrapper">
      <p>
        <strong>Kritikus pontok, fejlődési lehetőségek a házasságban:</strong>
        <br>Kígyóssy Örs és Andi
      </p>
      <p>
        <strong>Nagymaros, Szent Márton Közösségi Ház</strong>
        <br> február 1. vasárnap délután 16.00
      </p>

      <p>
        Gyerekvigyázás lesz az előadás alatt, ha szeretnéd hozni gyermekedet, kérjük jelezd a
       <a href="mailto:marosvet75 [kukac] gmail.com">marosvet75 [kukac] gmail.com</a> címre küldött e-maillel.
      </p>
    </div>

    <h2>Egy este "kettesben"</h2>
    <div class="list-wrapper">
      <p>
        Töltsetek egy estét kettesben, beszélgetve! Teremtsetek meghitt, nyugodt környezetet! Összeállítottunk pár segítő kérdést, ha gondoljátok, használjátok 
        őket a beszélgetéshez. A <router-link to="/trials">munkafüzetet</router-link> megtaláljátok a templomban, a könyvtárban vagy a honlapról is letölthetitek.
      </p>
    </div>

    <h2>"Hűség séta"</h2>
    <div class="list-wrapper">
      <p>
        <strong>Nagymaros, Római Katolikus Templom</strong>
        <br> február 10. kedd este 19.00
      </p>

      <p>
        Az idei házasság Hete meglepetés programja. A pároddal rövid sétára indítunk, apró meglepetésekkel készülünk. Öltözzetek fel jól, kb 1 órás lesz a program! 
        Ilyen még nem volt, ne féljetek, gyertek! Várunk benneteket!
      </p>
    </div>

    <h2>Házassági fogadalom megújítása</h2>
    <div class="list-wrapper">
      <p>
        <strong>Nagymaros, Római Katolikus Templom</strong>
        <br> február 15. vasárnap 9.30, záró szentmise
      </p>
      <p>A szentmise után Agapéra várunk benneteket a Közösségi Házba!</p>
    </div>

    <h2>Gyertyafényes vacsora</h2>
    <div class="list-wrapper">
      <p>
        Idén is szervezünk gyertyafényes vacsorát, kérünk jelezzétek részvételi szándékotokat a 
        <a href="mailto:marosvet75 [kukac] gmail.com">marosvet75 [kukac] gmail.com</a> címre küldött e-maillel, legkésőbb február 10-ig.
      </p>
      <p>
        <strong>Nagymaros, Szent Márton Közösségi Ház</strong>
        <br> február 13. péntek este 19.00
      </p>
      <p>Örülnénk, ha készülnétek a vacsira egy kis személyes megosztással, ez mindig feldobja az estét! Pár ötlet:</p>
      <ul>
        <li>Mesélhettek az esküvői meghívótokról, mit jelent nektek ez ma? Hozzátok is el, ha megvan!</li>
        <li>Mik azok a dolgok, amik az évek során megváltoztak bennetek? (Hajhagymák száma nem játszik!😆)</li>
        <li>Milyen bakik, vicces szituk voltak az esküvőtökön?</li>
      </ul>
    </div>

    <!--h2>Országos programajánló</h2>
    <div class="list-wrapper ads">
      <p>
        <a href="https://www.hazassaghete.hu/programok/viharallo-szerelem-3/">Viharálló szerelem</a> (Felsőgöd)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/ujra-kettesben/">Újra kettesben</a> (Bp. 5. kerület)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/torespontok-menten-nem-pillanatragasztoval/">Töréspontok mentén, nem pillanatragasztóval</a> (Online)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/oszinten-a-hazassagrol-paratlan-beszelgetes-kozismert-parokkal-2/">Őszintén a házasságról</a> (Bp. 8. kerület)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/2441/">Az AI és a szerelem</a> (Bp. 11. kerület)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/minden-madar-tarsat-valaszt-valoban-ismerkedes-es-parvalasztas-egykor-es-ma/">Minden Madár Társat Választ…</a> (Bp. 8. kerület)
      </p>
      <p>
        <a href="https://www.hazassaghete.hu/programok/zaro-szentmise-hazassag-hete-2025/">Országos záró szentmise.</a> <span>(Bp. 5. kerület)</span>
      </p>
    </div-->
  </div>
</template>

<script>
  export default {
    name: 'main'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ads p {
    display: flex;
    justify-content: space-between;

    a {
      display: inline-block;
      margin-right: 10px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
</style>